import React from 'react';
import styles from './Card.module.sass';

const Card = ({
    children,
    axis, state, width
}: Props) => {
    return <div className={`
        ${styles['card']}
        ${styles['card__axis--'+(axis||'vertical')]}
        ${styles['card__state--'+(state||'static')]}
        ${styles['card__width--'+(width||'full')]}
    `}>
        { children }
    </div>;
}

interface Props {
    children: any
    width?: 'full' | 'inline'
    axis?: 'horizontal' | 'vertical'
    state?: 'link' | 'static'
}

export default Card;